import React from 'react';
import { Modal, ModalBody } from 'Components/Modal';
import { FormHandler } from "Components/Form/index";
import Input from "Components/Form/Input";
import PrimaryButton from "Components/Button/PrimaryButton";
import Auth from 'Services/Api/Auth/Auth';
import { Loading } from "Components/Partials/index";
import { Alert } from "Components/Partials/index";
import { asset } from "Services/BaseHelpers";
import {Link} from "react-router-dom";

class RemoteLoginModel extends React.Component {
    state = {
        form: {
            first_name: '',
            last_name: '',
        },
        showSuccess: false,
        working: false,
    };

    handleSubmit = async () => {
        const { form } = this.props;
        const request = await Auth.anonymousLogin(form);

        this.setState({ working: true, errors: null, showSuccess: false });

        if (request.success) {
            this.setState({ working: false, showSuccess: true, errors: null });
            window.location.href = '/main-stage/remote';
        }

        if (request.errors) {
            return this.setState({
                errors: request.errors,
                working: false
            });
        }
    }

    handleClose = () => {
        this.handleSubmit();
    }

    renderItem = () => {
        const { errors, working, showSuccess } = this.state;
        const { getFieldError, handleInput, form } = this.props;

        return (
            <div className={``}>
                {working && <Loading />}
                <div className={"h-full w-full"}>
                        {/*<Link to={ '/admin/main-stage' }>*/}
                        {/*    <div className="w-full flex justify-center items-center">*/}
                        {/*        <img*/}
                        {/*            src={ asset('/images/box-text.png') }*/}
                        {/*            alt="logo"*/}
                        {/*            className="h-60"*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</Link>*/}
                    <div className="flex flex-col w-full items-center justify-center gap-5">
                        {showSuccess &&
                            <Alert
                                type="anon_success"
                                className="w-full text-app-agenda-lighter-blue"
                                message="You have been logged in and are now being redirected"
                            />
                        }

                        <div className={"my-5 lg:my-15"}>
                            <p className="text-center text-app-agenda-lighter-blue my-5">
                                Please enter your first and last name to continue
                            </p>

                            <Input
                                name="first_name"
                                label="First Name"
                                value={form.first_name}
                                onChange={v => handleInput('first_name', v)}
                                className="w-full"
                                error={errors?.first_name}
                                containerClassName="w-full mb-4"
                                labelColour={"text-app-agenda-lighter-blue"}
                            />

                            <Input
                                name="last_name"
                                label="Last Name"
                                value={form.last_name}
                                onChange={v => handleInput('last_name', v)}
                                className="w-full"
                                error={errors?.last_name}
                                containerClassName="w-full mb-4"
                                labelColour={"text-app-agenda-lighter-blue"}
                            />

                            <div className="flex justify-center flex-col items-center">
                                <PrimaryButton
                                    onClick={() => this.handleSubmit()}
                                    text="Submit"
                                >
                                </PrimaryButton>

                                <button
                                    className="text-app-blue mt-6"
                                    onClick={() => this.handleSubmit()}
                                >
                                    Skip
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { onClose, speaker } = this.props;

        return (
            <Modal titleClass="text-white" onClose={this.handleClose} className="bg-white text-app-agenda-lighter-blue max-w-screen-sm md:max-w-4xl text-white">
                <ModalBody>
                    <div className="relative flex flex-col items-center justify-center gap-5">
                        <button onClick={this.handleClose} className="absolute -top-5 right-0 m-4 text-white">X</button>
                        <div className="">
                            {this.renderItem()}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }
}

export default FormHandler(RemoteLoginModel);
